import React from "react";

import { useTranslation } from "react-i18next";

import InfoTooltip from "../../utils/InfoTooltip";

import type { JSX } from "react";

import type { StorefrontProjectParams } from "../../../api/ProjectAPI.types";

interface UserRegistrationConfigurationProps {
  requireRegistrationBeforeOffer: boolean;
  onChange: <K extends keyof StorefrontProjectParams>(
    key: K,
    value: StorefrontProjectParams[K],
  ) => void;
}

export default function UserRegistrationConfiguration({
  onChange,
  requireRegistrationBeforeOffer,
}: UserRegistrationConfigurationProps): JSX.Element {
  const { t } = useTranslation("editor-platform");
  return (
    <div className="editor-form-section section-separator">
      <div className="editor-form-section-title">{t("userRegistration")}</div>
      <div className="editor-form-row">
        <div key="radio-1" className="editor-form-radio-container">
          <div
            className={`editor-form-radio ${!requireRegistrationBeforeOffer ? "editor-form-radio-checked" : ""}`}
            onClick={(): void =>
              onChange("require_registration_before_offer", false)
            }
          />
          <div className="editor-form-label">
            {t("showOfferPostRegistration")}
          </div>
          <InfoTooltip width="500px">
            {t("showOfferTooltip")}
            <a
              className="link"
              href={t("editor-help:showOffer:link")}
              rel="noopener noreferrer"
              target="_blank"
            >
              {t("editor-help:showOffer:label")}
            </a>
          </InfoTooltip>
        </div>
      </div>
      <div className="editor-form-row">
        <div key="radio-2" className="editor-form-radio-container">
          <div
            className={`editor-form-radio ${requireRegistrationBeforeOffer ? "editor-form-radio-checked" : ""}`}
            onClick={(): void =>
              onChange("require_registration_before_offer", true)
            }
          />
          <div className="editor-form-label">
            {t("noShowOfferPostRegistration")}
          </div>
          <InfoTooltip width="500px">
            {t("noShowOfferTooltip")}
            <a
              className="link"
              href={t("editor-help:showOffer:link")}
              rel="noopener noreferrer"
              target="_blank"
            >
              {t("editor-help:showOffer:label")}
            </a>
          </InfoTooltip>
        </div>
      </div>
    </div>
  );
}
